import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import PageAdmin from '@/pages/PageAdmin'
import PageOfertas from '@/pages/PageOfertas'
import PageFormulario from '@/pages/PageFormulario'
import PageDiamante from '@/pages/PageDiamante'
import PageDiamanteFormulario from '@/pages/PageDiamanteFormulario'
import PageSessao from '@/pages/PageSessao'
import PageAtendimento from '@/pages/PageAtendimento'
import PageProtocoloDetalhe from '@/pages/PageProtocoloDetalhe'
import PageEstrelas from '@/pages/PageEstrelas'
import PageEstrelasDivulgar from '@/pages/PageEstrelasDivulgar'
import PageFormularioCiclo2 from '@/pages/PageFormularioCiclo2'
import PageFormularioCiclo3 from '@/pages/PageFormularioCiclo3'
import PageFormularioCiclo4 from '@/pages/PageFormularioCiclo4'
import PageFormularioCiclo5 from '@/pages/PageFormularioCiclo5'
import PageFormularioCiclo6 from '@/pages/PageFormularioCiclo6'
import PageFormularioMapaCura from '@/pages/PageFormularioMapaCura'
import PageApresentacao from '@/pages/PageApresentacao'
import PageCuraQuantica from '@/pages/PageCuraQuantica'
import PageAtendimentos from '@/pages/PageAtendimentos'
import { useRoutes } from 'react-router-dom'

function isApexBioHost(hostname: string) {
  return hostname.replace(/^www\./, '').toLowerCase() === 'reacendaluz.com.br'
}

function RootByHost() {
  if (typeof window !== 'undefined' && isApexBioHost(window.location.hostname)) {
    return <PageApresentacao />
  }
  return <Home />
}

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <RootByHost /> },
  { path: '/admin', element: <PageAdmin /> },
  { path: '/ofertas', element: <PageOfertas /> },
  { path: '/protocolo', element: <PageProtocoloDetalhe /> },
  { path: '/formulario', element: <PageFormulario /> },
  { path: '/diamante', element: <PageDiamante /> },
  { path: '/diamante/formulario', element: <PageDiamanteFormulario /> },
  { path: '/sessao', element: <PageSessao /> },
  { path: '/atendimento', element: <PageAtendimento /> },
  { path: '/estrelas', element: <PageEstrelas /> },
  { path: '/estrelas/divulgar', element: <PageEstrelasDivulgar /> },
  { path: '/formulario/ciclo2', element: <PageFormularioCiclo2 /> },
  { path: '/formulario/ciclo3', element: <PageFormularioCiclo3 /> },
  { path: '/formulario/ciclo4', element: <PageFormularioCiclo4 /> },
  { path: '/formulario/ciclo5', element: <PageFormularioCiclo5 /> },
  { path: '/formulario/ciclo6', element: <PageFormularioCiclo6 /> },
  { path: '/formulario/mapa', element: <PageFormularioMapaCura /> },
  { path: '/bio', element: <PageApresentacao /> },
  { path: '/curaquantica', element: <PageCuraQuantica /> },
  { path: '/atendimentos', element: <PageAtendimentos /> },
]

function App() {
  return useRoutes(routes)
}

export default App
